import React, {useEffect} from "react";
import {Alert, Button, Modal, Container} from "react-bootstrap";
import {attachFileToPandaDoc, setDocumentSent, createPandaDocFromTemplate} from "../services/PandaDocService";
import {updatePDFFileName} from "../services/Leadservice";
import LoadingLoginScreen from "./LoadingLoginScreen";

export const AcceptAndSendQuoteModal = ({customer, currentUser, service, amount, file, lead, docid}) => {


    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [errorVariant, setErrorVariant] = React.useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
let timer;

    useEffect(() => {
        if (file === null) {
            setError(true);
            setErrorText("Ingen fil är bifogad.")
        }
    }, [file])


    const handleSendDocument = async () => {
   
        try {
            setLoading(true);
             await createPandaDocFromTemplate(
                docid,
                lead.email,
                lead.firstname,
                lead.lastname,
                lead.value,
                currentUser.email,
                lead.service,
                lead.company)
               

                setError(true);
                setErrorVariant("success")

                setErrorText(`Offert till ${lead.email} skapad`);
            timer = setTimeout(() => {
                window.location.reload();
            }, 2000)    
            }
         catch (e) {
            console.log(e)
        }

    }


    return (
        <>
{loading ? <Container> Laddar</Container> : 
        <React.Fragment>

<Button variant="success" onClick={handleShow}>
                Påbörja offert
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Slutför offert</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <LoadingLoginScreen/> : null}

                    {error ? <Alert variant={"success"}>{errorText}</Alert> : null}
                    Skicka offert till: {customer}
                    <hr/>
                    Tjänsen är: {service}
                    <hr/>
                    Kostnad (inklusive moms): {amount}

                </Modal.Body>
                <Modal.Footer>
                   
                    {loading ? <React.Fragment>Offert skapad, bifoga nu fil</React.Fragment>: 
                    <React.Fragment>
                    <Button variant="secondary" onClick={handleClose}>
                        Stäng
                    </Button>
                    <Button variant="primary"  onClick={handleSendDocument}>
                        Godkänn och skapa Offert
                    </Button>
                    
                    </React.Fragment>
                }
                </Modal.Footer>
            </Modal>
            </React.Fragment>
        }

        </>
    );
}
